import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import YetsanLogo from '../components/YetsanLogo';
import { girisIntroIsaretle } from '../components/kalibre/GirisIntro';
import { useAuth } from '../context/AuthContext';
import { Package, Lock, Mail, ArrowLeft } from 'lucide-react';

const WMSLogin = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const { login, isAuthenticated, user } = useAuth();
  const navigate = useNavigate();
  
  // Eğer zaten giriş yapılmışsa ve firma kullanıcısıysa ana menüye yönlendir
  useEffect(() => {
    if (isAuthenticated && user && user.role === 'firma') {
      navigate('/wms/ana-menu');
    }
  }, [isAuthenticated, user, navigate]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      const result = await login(email, password);
      
      if (result.success) {
        // Sadece firma kullanıcıları WMS'e girebilir
        if (result.user && result.user.role === 'firma') {
          girisIntroIsaretle();               // ana girişteki Yetsan lazer açılışı WMS girişinde de
          navigate('/wms/ana-menu');
        } else {
          setError('Sadece firma kullanıcıları WMS\'e erişebilir');
          setLoading(false);
        }
      } else {
        setError(result.error || 'Giriş başarısız');
        setLoading(false);
      }
    } catch (err) {
      setError('Bir hata oluştu');
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-green-50 to-emerald-100 flex items-center justify-center p-2 sm:p-4">
      <div className="max-w-md w-full">
        {/* Back Button */}
        <button
          onClick={() => navigate('/sistem-sec')}
          className="mb-4 sm:mb-6 flex items-center gap-2 text-gray-600 hover:text-gray-800 transition"
        >
          <ArrowLeft size={20} />
          <span>Geri Dön</span>
        </button>

        {/* Login Card */}
        <div className="bg-white rounded-2xl shadow-2xl p-2 sm:p-2 sm:p-4 lg:p-8">
          {/* Logo */}
          <div className="bg-gradient-to-br from-green-500 to-emerald-600 w-20 h-20 rounded-2xl flex items-center justify-center mx-auto mb-4 sm:mb-6">
            <Package size={40} className="text-white" />
          </div>

          <h1 className="mb-2 flex justify-center"><YetsanLogo boy={28} sistem="WMS" renk="#0B2523" /></h1>
          <p className="text-center text-gray-600 mb-4 sm:mb-8">Depo Yönetim Sistemi</p>

          {/* Error Message */}
          {error && (
            <div className="bg-red-50 border border-red-200 text-red-700 px-4 py-3 rounded-lg mb-4 sm:mb-6">
              {error}
            </div>
          )}

          {/* Login Form */}
          <form onSubmit={handleSubmit} className="space-y-6">
            {/* Email */}
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                E-posta
              </label>
              <div className="relative">
                <Mail className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" size={20} />
                <input
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  className="w-full pl-10 pr-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-transparent"
                  placeholder="ornek@firma.com"
                  required
                />
              </div>
            </div>

            {/* Password */}
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Şifre
              </label>
              <div className="relative">
                <Lock className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" size={20} />
                <input
                  type="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  className="w-full pl-10 pr-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-transparent"
                  placeholder="••••••••"
                  required
                />
              </div>
            </div>

            {/* Submit Button */}
            <button
              type="submit"
              disabled={loading}
              className="w-full bg-gradient-to-r from-green-500 to-emerald-600 text-white py-3 rounded-lg font-semibold hover:from-green-600 hover:to-emerald-700 transition disabled:opacity-50 disabled:cursor-not-allowed"
            >
              {loading ? 'Giriş yapılıyor...' : 'Giriş Yap'}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default WMSLogin;
